async function parseResponse(response) {
  const payload = await response.json();
  if (response.status >= 200 && response.status < 300) {
    return payload;
  }
  const error = new Error(payload);
  error.code = response.status;
  throw error;
}

export { parseResponse }; // eslint-disable-line import/prefer-default-export
